import { createBrowserRouter } from "react-router-dom";

import { RootLayout } from "./RootLayout";

import { ContactEditPage } from "@/features/contactedit";
import { HomePage } from "@/features/home/HomePage";
import { NotFoundPage } from "@/features/home/NotFoundPage";
import { RespondPage } from "@/features/respond/RespondPage";
import { UploadPage } from "@/features/upload/UploadPage";
import { LanguageRoute } from "@/i18n/LanguageRoute";
import { RedirectToDetectedLocale } from "@/i18n/RedirectToDetectedLocale";

/**
 * customer SPA のルート定義。
 *
 * 構造: `/:lang/...` の lang セグメントが言語決定の一次ソース。
 * `/` および lang プレフィックスなしのパスは検出言語へリダイレクト。
 * 新規 feature を追加する場合は、`/:lang` 配下の children に <Route> を追加する。
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <RedirectToDetectedLocale />,
  },
  {
    path: "/:lang",
    element: <LanguageRoute />,
    children: [
      {
        element: <RootLayout />,
        errorElement: <NotFoundPage />,
        children: [
          { index: true, element: <HomePage /> },
          { path: "u/:campaignRecordId", element: <UploadPage /> },
          { path: "r/:campaignId/:respondentId", element: <RespondPage /> },
          // backend/handlers/contactedit_verify.go の redirectURL と一致させること (ADR-0041)。
          {
            path: "c/:campaignRecordId/:respondentRecordId",
            element: <ContactEditPage />,
          },
          { path: "*", element: <NotFoundPage /> },
          // /result/:customerId/:periodYm/:batchId/:deliveryId — 結果 PDF DL (将来)
        ],
      },
    ],
  },
  {
    path: "*",
    element: <RedirectToDetectedLocale />,
  },
]);
